module.exports = __webpack_public_path__ + "images/category_lp/retro_game/store_images/5_814bd3612272eb944a4e04541663186a.png";